import { useContext } from 'react';

import { HoneycombLoadingContext } from '../context/honeycomb-loading.context.js';

export const useHoneycombLoading = () => useContext(HoneycombLoadingContext);
